export enum MeasurementSystemType {
  Unknown = 0,
  Metric = 1,
  Imperial = 2
}
